module.exports = __webpack_public_path__ + "static/assets/f8699682cbd2d5edf0e849f48717c86c.svg";